
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '@/components/Layout/Layout';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

const AdminPage = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="container mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Carolina Trophy Roofs Admin</h1>
            <p className="text-xl text-gray-600">
              Access the content management system for your website
            </p>
          </div>
          
          <Card className="mb-8">
            <CardHeader>
              <CardTitle>BlogCraftAI Dashboard</CardTitle>
              <CardDescription>
                Manage your blog content, gallery, and website settings
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Our content management system allows you to:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Create and edit blog posts</li>
                <li>Upload and manage gallery images</li>
                <li>Set up templates for consistent blog formatting</li>
                <li>Define variables for easy content updates</li>
              </ul>
            </CardContent>
            <CardFooter className="flex flex-col sm:flex-row gap-4">
              <Button onClick={() => navigate('/auth')} className="w-full sm:w-auto">
                Login to Dashboard
              </Button>
              <Button variant="outline" onClick={() => navigate('/home')} className="w-full sm:w-auto">
                Return to Website
              </Button>
            </CardFooter>
          </Card>
          
          <div className="text-center text-sm text-gray-500">
            <p>
              For assistance with your account or content management system,<br />
              please contact your website administrator.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdminPage;
